import "../styles.css"

export default function Credits() {
  return (
    <>
    <div className='test2' >  hello Credits </div>
    </>
  );
}
